import { FC, useState,useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import 'yup-phone';
import Button from '../../../styled/Button';
import Text from '../../../styled/Text';
import Spacer from '../../../styled/Spacer';
import backendApi from '../../../api/backendApi';
import { LOGIN_QUERY } from '../../../constants/queries/user';
import { errorToast } from '../../../utils/toasts';
import styled from 'styled-components';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';
import selectCountry from './../../../utils/selectCountry';
import ReactFlagsSelect from 'react-flags-select';

interface Step1Props {
  setTab: Function;
  setLoginData: Function;
}

const LoginFormWrapper = styled.div`
  input.form-control {
    font-family: ${props => props.theme.fontFamily.manrope};
    height: 44px;
    border: 1px solid #8993a4;
    border-radius: 4px;
    font-size: 14px;
  }
  .countrySelect {
    & > div {
      height: 44px;
      border: 1px solid #8993a4;
    }
  }
  .bottomLink {
    font-size: 16px;
    font-weight: 700;
    button {
      font-weight: 700;
      font-size: 16px;
    }
  }
`;

const customStyles = {
  control: () => ({
    innerHeight: '44px',
  }),
};


const Step1: FC<Step1Props> = ({ setTab, setLoginData }) => {
  const geolocation = useSelector(
    (store: RootState) => store.location.geolocation,
  );

  const [code, setCode] = useState<string>(geolocation == 'in' ? '91' : '1');
  const [country, setCountry] = useState<string>(geolocation == 'in' ? 'IN' : 'US');
  let loginSchema = (country == "IN") ? ( yup.object().shape({
    mobile: yup
      .string()
      .phone()
      .test('len', (val: string | undefined, { createError, path }) =>
        val?.length === 10
          ? true
          : createError({
            path,
            message: 'Phone number should be valid and 10 digits long',
          }),
      )
      .required(),
  })):( yup.object().shape({
    mobile: yup
      .string()
      .required(),
  })); 
  const setCountryCode = (code: string) => {
    let country = selectCountry(code);
    setCode(country)
    setCountry(code);
  }
  useEffect(() => {
  loginSchema  = (country == "IN") ? ( yup.object().shape({
      mobile: yup
        .string()
        .phone()
        .test('len', (val: string | undefined, { createError, path }) =>
          val?.length === 10
            ? true
            : createError({
              path,
              message: 'Phone number should be valid and 10 digits long',
            }),
        )
        .required(),
    })):( yup.object().shape({
      mobile: yup
        .string()
        .required(),
    }));
  }, [country]);
 
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    getValues,
  } = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      mobile: '',
    },
  });

  const onSubmit = (data: any) => {
    backendApi 
      .post('/', {
        query: LOGIN_QUERY,
        variables: {
          mobile: parseFloat(data.mobile),
          countryCode: parseInt(code),
        },
      })
      .then(res => {
        if (res.data.data) {
          setLoginData(res.data.data.loginUser);
        } else if (res.data.errors.length) {
          throw new Error(res.data.errors[0].message);
        }
      })
      .catch(error => {
        errorToast(error.message);
      });
  };

  return (
    <LoginFormWrapper>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Text fontSize="lg" color="gray" weight="midbold">
          Login by Mobile No.
        </Text>
        <Spacer direction="vertical" size={15} />
        <div className="d-flex">
          <div>
            <ReactFlagsSelect
              selected={country}
              onSelect={code => { setCountryCode(code) }}
              countries={["IN", "US", "GB", "CA", "ZA", "AU", "SG", "MY", "AE", "SA"]}
              optionsSize={14}
              customLabels={{ "IN": "+91", "US": "+1", "GB": "+44", "CA": "+1", "ZA": "+27", "AU": "+61", "SG": "+65", "MY": "+60", "AE": "+971", "SA": "+966" }}
            />
          </div>
          <Spacer direction="horizontal" size={6} />
          <div className="w-100">
            <input
              className="form-control"
              placeholder="Enter valid mobile no."
              data-clarity-unmask="True"
              {...register('mobile')}
            />
          </div>
        </div>
        {errors.mobile && (
          <Text color="red" fontSize="xs">
            Invalid mobile number
          </Text>
        )}
        <Spacer direction="vertical" size={30} />
        <Button size="md" block rounded color="white" backgroundColor="primary">
          Login
        </Button>
        <Spacer direction="vertical" size={100} />
        <Text center fontSize="md" color="gray" className="bottomLink">
          New to EzyLegal?
          <Text
            as="button"
            fontSize="md"
            inline
            color="primary"
            style={{
              background: 'transparent',
              border: 'unset',
            }}
            onClick={() => setTab('SIGNUP')}
          >
            Create an Account
          </Text>
        </Text>
      </form>
    </LoginFormWrapper>
  );
};

export default Step1; 
